import React, { useState, useEffect } from "react";
import { OverlayTrigger, Tooltip, Row, Col, Container, Card, CardBody, Table } from "react-bootstrap"
import {
    getSummary, saveSummary, getSummaryBasinOptions, getRequestId
} from "../../Services/dashboard";
import s3sLogo from '../../assets/images/s3sLogo.png'; // adjust path as needed
import { ToastContainer, toast } from "react-toastify";
import FullScreenLoader from "../../Component/Loader";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router";
import Header from "../../Component/Header";
import storageIcon from '../../assets/images/storage-web-icon.svg';
import notesWebIcon from '../../assets/images/note-web-icon.svg';
import checkCircleIcon from '../../assets/images/check-circle-icon.svg';
import deployIcon from '../../assets/images/deploy-icon.svg';
import resupplyIcon from '../../assets/images/resupply.svg';
import trangleExclamtionIcon from '../../assets/images/exclamation-icon-red.svg';
import circleExclamtionIcon from '../../assets/images/exclamation-icon-circle-org.svg';
import checkDeployIcon from '../../assets/images/check-deployed-icon.svg';
import "./style.css"
import { useDispatch } from "react-redux";
import { setRequestType } from "../../Redux/Slice/requestTypeSlice";


function ViewSummary() {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const { deal_id, job_id, country } = useParams();
    const [showLoader, setShowLoader] = useState(false);
    const [summaryData, setSummaryData] = useState({});
    const [assetData, setAssetData] = useState(false);
    const [isDeployEnabled, setIsDeployEnabled] = useState(false);
    const [selectedBasin, setSelectedBasin] = useState({
        basin: "All",
        isDeployed: false,
        deployedDate: ""
    });
    const [basinOptions, setBasinOptions] = useState([]);
    const [requestId, setRequestId] = useState(null);


    useEffect(() => {
        if (job_id) {
            fetchBasin()
        }
    }, [job_id]);

    useEffect(() => {
        if (job_id) {
            fetchRequestId()
            fetchSummary(job_id)
        }
    }, [job_id, selectedBasin]);

    let fetchRequestId = async () => {
        let res = await getRequestId(localStorage.access_token, job_id)
        if (res && res?.data && res?.data.status == 200) {
            if (res?.data?.data?.length) {
                setRequestId(res?.data?.data[0].Active_Request_ID)
            }
        }

    }
    console.log("acti->", requestId)

    // Function to check if all "Ready To Ship" checkboxes are checked
    const checkAllReadyToShip = (data) => {
        if (!data || !data.summary) return false;
        const categories = [
            'Equipment',
            'Hose',
            'Items',
            'LabEquipment',
            'HSE',
            '3rdPartyEquipment',
            'CustomPackageItem'
        ];

        // Helper function to check items in an array
        const checkArrayItems = (array) => {
            if (!Array.isArray(array) || array.length === 0) return true; // Empty arrays are considered "all checked"
            return array.every(item => item.Loaded === true);
        };

        // Helper function to flatten and check Items category
        const checkItemsCategory = (itemsData) => {
            if (!itemsData || !Array.isArray(itemsData)) return true;

            const allItems = [];

            // Collect all items from Items category
            itemsData.forEach(category => {
                if (category && typeof category === 'object') {
                    // Add items from main category
                    if (category.items && Array.isArray(category.items)) {
                        allItems.push(...category.items);
                    }
                    // Add items from subcategories
                    if (category.SubCategory && Array.isArray(category.SubCategory)) {
                        category.SubCategory.forEach(subCategory => {
                            if (subCategory.items && Array.isArray(subCategory.items)) {
                                allItems.push(...subCategory.items);
                            }
                        });
                    }
                }
            });

            if (allItems.length === 0) return true;
            return allItems.every(item => item.Loaded === true);
        };

        // Check each category
        for (const category of categories) {
            if (category === 'Items') {
                if (!checkItemsCategory(data.summary[category])) {
                    return false;
                }
            } else {
                if (!checkArrayItems(data.summary[category])) {
                    return false;
                }
            }
        }

        return true;
    };

    // Update deploy button state when summaryData changes
    useEffect(() => {
        if (summaryData && Object.keys(summaryData).length > 0) {
            const isEnabled = checkAllReadyToShip(summaryData);
            setIsDeployEnabled(isEnabled);
        }
    }, [summaryData]);


    let fetchBasin = async () => {
        let res = await getSummaryBasinOptions(localStorage.access_token, job_id, country)
        if (res?.data?.result) {
            const withAllOption = [
                {
                    basin: "All",
                    isDeployed: false,
                    deployedDate: ""
                },
                ...res.data.result
            ]

            setBasinOptions(withAllOption)
        }
    }



    let fetchSummary = async (id) => {
        try {
            setShowLoader(true);
            let getCountry = country == 'USA' ? 'USA' : 'Canada'
            let res = await getSummary(localStorage?.access_token, id, selectedBasin.basin);
            setShowLoader(false);
            if (res.status === 200) {
                if (res.data?.status_code === 200) {
                    setSummaryData(res.data?.result);
                }

                const result = hasSummaryData(res?.data?.result?.summary);
                setAssetData(result)
            }

        } catch (err) {
            console.error("Error fetching hoses:", err);
            setShowLoader(false);
        }
    }


    function hasSummaryData(summary) {
        return Object.values(summary).some(
            arr => Array.isArray(arr) && arr.length > 0
        );
    }

    // Update checkbox change handlers to update state after change
    const updateCheckboxState = (updatedData) => {
        setSummaryData(updatedData);
    };

    // Handle checkbox changes for Equipment
    const handleEquipmentCheckboxChange = (categoryIndex, field, checked) => {
        setSummaryData(prevData => {
            const updatedSummary = { ...prevData.summary };
            const updatedEquipment = [...updatedSummary.Equipment];

            updatedEquipment[categoryIndex] = {
                ...updatedEquipment[categoryIndex],
                [field]: checked
            };

            updatedSummary.Equipment = updatedEquipment;

            const updatedData = {
                ...prevData,
                summary: updatedSummary
            };

            // Update state immediately after checkbox change
            updateCheckboxState(updatedData);

            return updatedData;
        });
    };

    // Handle checkbox changes for Hose
    const handleHoseCheckboxChange = (hoseIndex, field, checked) => {
        setSummaryData(prevData => {
            const updatedSummary = { ...prevData.summary };
            const updatedHose = [...updatedSummary.Hose];

            updatedHose[hoseIndex] = {
                ...updatedHose[hoseIndex],
                [field]: checked
            };

            updatedSummary.Hose = updatedHose;

            const updatedData = {
                ...prevData,
                summary: updatedSummary
            };

            updateCheckboxState(updatedData);

            return updatedData;
        });
    };

    // Handle checkbox changes for Items
    const handleItemsCheckboxChange = (categoryIndex, itemIndex, field, checked, hasSubCategory = false, subCategoryIndex = null) => {
        setSummaryData(prevData => {
            const updatedSummary = { ...prevData.summary };
            const updatedItems = [...updatedSummary.Items];

            if (hasSubCategory && subCategoryIndex !== null) {
                // For items with subcategories
                const updatedSubCategory = [...updatedItems[categoryIndex].SubCategory];
                const updatedSubItems = [...updatedSubCategory[subCategoryIndex].items];

                updatedSubItems[itemIndex] = {
                    ...updatedSubItems[itemIndex],
                    [field]: checked
                };

                updatedSubCategory[subCategoryIndex] = {
                    ...updatedSubCategory[subCategoryIndex],
                    items: updatedSubItems
                };

                updatedItems[categoryIndex] = {
                    ...updatedItems[categoryIndex],
                    SubCategory: updatedSubCategory
                };
            } else {
                // For items without subcategories
                const updatedCategoryItems = [...updatedItems[categoryIndex].items];

                updatedCategoryItems[itemIndex] = {
                    ...updatedCategoryItems[itemIndex],
                    [field]: checked
                };

                updatedItems[categoryIndex] = {
                    ...updatedItems[categoryIndex],
                    items: updatedCategoryItems
                };
            }

            updatedSummary.Items = updatedItems;

            const updatedData = {
                ...prevData,
                summary: updatedSummary
            };

            updateCheckboxState(updatedData);

            return updatedData;
        });
    };

    // Handle checkbox changes for Lab Equipment
    const handleLabEquipmentCheckboxChange = (labIndex, field, checked) => {
        setSummaryData(prevData => {
            const updatedSummary = { ...prevData.summary };
            const updatedLabEquipment = [...updatedSummary.LabEquipment];

            updatedLabEquipment[labIndex] = {
                ...updatedLabEquipment[labIndex],
                [field]: checked
            };

            updatedSummary.LabEquipment = updatedLabEquipment;

            const updatedData = {
                ...prevData,
                summary: updatedSummary
            };

            updateCheckboxState(updatedData);

            return updatedData;
        });
    };

    // Handle checkbox changes for HSE
    const handleHSECheckboxChange = (hseIndex, field, checked) => {
        setSummaryData(prevData => {
            const updatedSummary = { ...prevData.summary };
            const updatedHSE = [...updatedSummary.HSE];

            updatedHSE[hseIndex] = {
                ...updatedHSE[hseIndex],
                [field]: checked
            };

            updatedSummary.HSE = updatedHSE;

            const updatedData = {
                ...prevData,
                summary: updatedSummary
            };

            updateCheckboxState(updatedData);

            return updatedData;
        });
    };

    // Handle checkbox changes for 3rd Party Equipment
    const handleThirdPartyCheckboxChange = (thirdPartyIndex, field, checked) => {
        setSummaryData(prevData => {
            const updatedSummary = { ...prevData.summary };
            const updatedThirdParty = [...updatedSummary['3rdPartyEquipment']];

            updatedThirdParty[thirdPartyIndex] = {
                ...updatedThirdParty[thirdPartyIndex],
                [field]: checked
            };

            updatedSummary['3rdPartyEquipment'] = updatedThirdParty;

            const updatedData = {
                ...prevData,
                summary: updatedSummary
            };

            updateCheckboxState(updatedData);

            return updatedData;
        });
    };

    // Handle checkbox changes for Custom Package Item
    const handleCustomPackageCheckboxChange = (customIndex, field, checked) => {
        setSummaryData(prevData => {
            const updatedSummary = { ...prevData.summary };
            const updatedCustomPackage = [...updatedSummary.CustomPackageItem];

            updatedCustomPackage[customIndex] = {
                ...updatedCustomPackage[customIndex],
                [field]: checked
            };

            updatedSummary.CustomPackageItem = updatedCustomPackage;

            const updatedData = {
                ...prevData,
                summary: updatedSummary
            };

            updateCheckboxState(updatedData);

            return updatedData;
        });
    };

    function convertToPayload(data, type) {
        if (!data || typeof data !== 'object') {
            throw new Error('Invalid data provided');
        }

        const createSummaryArray = (sourceArray, idKey = 'ID') => {
            if (!sourceArray || !Array.isArray(sourceArray)) return [];
            return sourceArray.map(item => ({
                [idKey]: item[idKey] || item.EquipmentID || 0,
                Loaded: Boolean(item.Loaded),
                Recieved: Boolean(item.Recieved),
                isDeployed: type === 'deploy' ? true : Boolean(item.isDeployed)
            }));
        };

        const flattenItems = (itemsData) => {
            if (!itemsData || !Array.isArray(itemsData)) return [];

            const allItems = [];

            const processItemsArray = (itemsArray) => {
                if (!itemsArray || !Array.isArray(itemsArray)) return;

                itemsArray.forEach(item => {
                    if (item && typeof item === 'object') {
                        allItems.push({
                            ID: item.ID || 0,
                            Loaded: Boolean(item.Loaded),
                            Recieved: Boolean(item.Recieved)
                        });
                    }
                });
            };

            itemsData.forEach(category => {
                if (category && typeof category === 'object') {
                    processItemsArray(category.items);
                    if (category.SubCategory && Array.isArray(category.SubCategory)) {
                        category.SubCategory.forEach(subCategory => {
                            processItemsArray(subCategory.items);
                        });
                    }
                }
            });

            return allItems;
        };

        return {
            summary: {
                Equipment: createSummaryArray(data.Equipment, 'EquipmentID'),
                Hose: createSummaryArray(data.Hose),
                Items: flattenItems(data.Items),
                CustomPackageItem: createSummaryArray(data.CustomPackageItem),
                LabEquipment: createSummaryArray(data.LabEquipment),
                HSE: createSummaryArray(data.HSE),
                ThirdPartyEquipment: createSummaryArray(data["3rdPartyEquipment"]),
                deployed: {
                    basin: selectedBasin.basin,
                    isDeployed: true,
                    deployedDate: new Date().toISOString().slice(0, 19).replace('T', ' ')
                }
            }
        };
    }

    let handleSave = async (type) => {
        const result = convertToPayload(summaryData?.summary, type);

        setShowLoader(true);

        const getCountry = country === 'USA' ? 'USA' : 'Canada';

        let res = await saveSummary(
            localStorage.access_token,
            result,
            getCountry,
            job_id,
            type === 'deploy'
        );

        fetchSummary(job_id);
        fetchBasin()
        if (res && res.status === 200 && res.data?.status_code === 200) {
            toast.success(res.data?.message || "Equipment details saved successfully!");
        } else {
            toast.error("Failed to save ❌");
        }
    };


    // Handle deploy action
    const handleDeploy = async () => {
        await handleSave('deploy');
    }
    let handleBsinFilterClick = (val) => {
        setSelectedBasin(val)
    }
    const getStatusClass = (status) => {
        switch (status) {
            case false:
                return 'btn-inprogress-txt';
            case true:
                return 'btn-deployed-txt';
            default:
                return 'btn-inprogress-txt';
        }
    }

    const checkAllItemsDeployed = (summary) => {
        if (!summary) return false;

        const categories = ['Equipment', 'Hose', 'Items', 'LabEquipment', 'HSE', '3rdPartyEquipment', 'CustomPackageItem'];

        for (const cat of categories) {
            const items = summary[cat];
            if (!items || !Array.isArray(items)) continue;

            if (cat === 'Items') {
                // Items structure: array of categories, each with items and/or SubCategory
                for (const category of items) {
                    // Direct items
                    if (category.items && Array.isArray(category.items)) {
                        for (const item of category.items) {
                            if (item.IsDeployed !== true) return false;
                        }
                    }
                    // SubCategory items
                    if (category.SubCategory && Array.isArray(category.SubCategory)) {
                        for (const sub of category.SubCategory) {
                            if (sub.items && Array.isArray(sub.items)) {
                                for (const item of sub.items) {
                                    if (item.IsDeployed !== true) return false;
                                }
                            }
                        }
                    }
                }
            } else {
                // Other categories: each item has IsDeployed directly
                for (const item of items) {
                    if (item.IsDeployed !== true) return false;
                }
            }
        }

        return true; // all items are deployed
    };

    function areAllBasinsDeployed(data) {
        return data
            .filter(item => item.basin !== "All")
            .every(item => item.isDeployed === true);
    }

    // Print handler
    const handlePrint = () => {
        window.print();
    };

    let handleResupplyClick = () => {
        dispatch(setRequestType({ RequestType: 'Resupply' }));
        localStorage.setItem('requestType', 'Resupply')
        if (!requestId) {
            navigate(`/home/${deal_id}/${country}?requestType=Resupply&jobDetailsId=${job_id}`)
        } else {
            navigate(`/home/${job_id}/${requestId}/${deal_id}/${country}`)
        }
    }

    return (
        <>
            <div className="wrapper">
                {showLoader ? <FullScreenLoader></FullScreenLoader> : null}
                <Header />
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    pauseOnHover
                    draggable
                    theme="colored"
                />
                <div className="full-assets-mange">
                    <Container fluid>
                        <Row>
                            <Col xs={12}>
                                <div className="d-flex align-items-start mb-3">

                                    {/* LEFT: BREADCRUMB */}
                                    <div className="flex-shrink-0">
                                        <ul className="d-flex align-items-center breadcum-menu-pg mb-0">
                                            <li className="list-breadcum-mn">
                                                <button
                                                    type="button"
                                                    className="btn p-0 border-0 itm-txtwgt-breadcum"
                                                    onClick={() => navigate(`/home/${deal_id}/${country}`)}
                                                >
                                                    Request form
                                                </button>
                                            </li>
                                            <li className="list-breadcum-mn">
                                                <span className="itm-txtwgt-breadcum">
                                                    Load out summary
                                                </span>
                                            </li>
                                        </ul>
                                    </div>

                                    {/* MIDDLE: BASINS (CENTERED BETWEEN) */}
                                    <div className="flex-grow-1 d-flex justify-content px-3">
                                        <div className="d-flex flex-wrap gap-2">
                                            {basinOptions.map((val, i) => (
                                                <div
                                                    key={i}
                                                    className="d-flex flex-column align-items-center"
                                                >
                                                    <button
                                                        onClick={() => handleBsinFilterClick(val)}
                                                        type="button"
                                                        className={`btn btn-web-deploy-filter ${selectedBasin.basin === val.basin ? "active" : val.isDeployed ? "deployed" : ""
                                                            }`}
                                                    >
                                                        {val.basin}
                                                    </button>

                                                    {val.basin !== "All" && (
                                                        <p className="basin-date">{val.deployedDate ? new Date(val.deployedDate).toLocaleDateString("en-GB").replace(/\//g, "-")
                                                            : ''}</p>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {/* RIGHT: DEPLOY / RESUPPLY */}
                                    <div
                                        className="flex-shrink-0 d-flex align-items-center"
                                        style={{ gap: "5px" }}
                                    >
                                        {checkAllItemsDeployed(summaryData?.summary) && (
                                            <button
                                                onClick={() => handleResupplyClick()}
                                                type="button"
                                                className="btn btn-web-resupply"
                                            >
                                                <img src={resupplyIcon} className="me-2" alt="" />
                                                Resupply
                                            </button>
                                        )}

                                        {/* <button
                                            onClick={handleDeploy}
                                            disabled={
                                                selectedBasin.basin === "All"
                                                    ? areAllBasinsDeployed(basinOptions)
                                                    : selectedBasin.isDeployed
                                            }
                                            type="button"
                                            className="btn btn-web-deploy"
                                        >
                                            <img src={deployIcon} className="me-2" alt="" />
                                            Deploy
                                        </button> */}
                                        <button
                                            onClick={handleDeploy}
                                            disabled={
                                                selectedBasin.basin === "All"
                                                    ?
                                                    checkAllItemsDeployed(summaryData?.summary)
                                                    : selectedBasin.isDeployed
                                            }
                                            type="button"
                                            className="btn btn-web-deploy"
                                        >
                                            <img src={deployIcon} className="me-2" alt="" />
                                            Deploy
                                        </button>
                                    </div>

                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={12} md={12} lg={3} className="col-grid-web-2 pe-0">
                                <div className="side-card-summry mb-3 mb-md-5">
                                    <Card className="card-boxdtl mb-3">
                                        <CardBody className="px-2">
                                            <div className="d-flex align-items-center justify-content-between headline-wapflx pb-3">
                                                <h3 className="title-head-wp mb-0">Job Details</h3>
                                                <div className="ps-2">
                                                    <span
                                                        style={{ cursor: 'pointer' }}
                                                        className="txt-btn-proty-deploy"
                                                        onClick={handlePrint}
                                                    >
                                                        <img src={checkDeployIcon} className="me-1" alt="" />Print
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="multi-list-dtlasts">
                                                <div className="list-grid--itm">
                                                    <h5 className="lst-ttl-mnt">Job Name</h5>
                                                    <h3 className="wgt-title-pt">{summaryData?.jobDetails?.[0]?.JobName}</h3>
                                                </div>
                                                <div className="list-grid--itm">
                                                    <h5 className="lst-ttl-mnt">CUSTOMER NAME</h5>
                                                    <h3 className="wgt-title-pt">{summaryData?.jobDetails?.[0]?.CustomerName}</h3>
                                                </div>
                                                <div className="list-grid--itm">
                                                    <h5 className="lst-ttl-mnt">Rig/Platform Name </h5>
                                                    <h3 className="wgt-title-pt">{summaryData?.jobDetails?.[0]?.PlatformName}</h3>
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                    <Card className="card-boxdtl">
                                        <CardBody className="px-2">
                                            <div className="headline-wapflx pb-3">
                                                <h3 className="title-head-wp mb-0">General Information</h3>
                                            </div>
                                            <div className="multi-list-dtlasts">
                                                <div className="list-grid--itm">
                                                    <h5 className="lst-ttl-mnt">Customer PO Number</h5>
                                                    <h3 className="wgt-title-pt">{ }</h3>
                                                </div>
                                                <div className="list-grid--itm">
                                                    <h5 className="lst-ttl-mnt">Internal Job ID</h5>
                                                    <h3 className="wgt-title-pt">{summaryData?.generalInformation?.[0]?.ID}</h3>
                                                </div>
                                                <div className="list-grid--itm">
                                                    <h5 className="lst-ttl-mnt">Area Manager</h5>
                                                    <h3 className="wgt-title-pt">{summaryData?.generalInformation?.[0]?.AreaManager}</h3>
                                                </div>
                                                <div className="list-grid--itm">
                                                    <h5 className="lst-ttl-mnt">Field Leader</h5>
                                                    <h3 className="wgt-title-pt">{summaryData?.generalInformation?.[0]?.FieldLeader}</h3>
                                                </div>
                                                <div className="list-grid--itm">
                                                    <h5 className="lst-ttl-mnt">Primary Basin</h5>
                                                    <h3 className="wgt-title-pt">{summaryData?.generalInformation?.[0]?.PrimaryBasin}</h3>
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </div>
                            </Col>
                            <Col xs={12} md={12} lg={9} className="col-grid-web-1" id="print-div">
                                <Card className="card-sumry-waps mb-5">
                                    <CardBody className="px-0 card-bd-scroll">
                                        <div className="assets-summry-wgt">

                                            {
                                                summaryData?.summary?.Equipment?.length ?
                                                    <>
                                                        <div className="multi-category-chartlist">
                                                            <div className="flx-category-emt">
                                                                <div className="flx-icon-wtm"><img src={storageIcon} alt="" /></div>
                                                                <div className="info-wpl-info">
                                                                    <span className="small-tl-sp">category</span>
                                                                    <h3 className="title-mgt--wp">EQUIPMENT</h3>
                                                                </div>
                                                            </div>
                                                            <div className="assets-table-sumry px-4">
                                                                <Table responsive className="table-summary-elemnt">
                                                                    <thead className="thead-web-sumr">
                                                                        <tr>
                                                                            <th>Sls Asset Type</th>
                                                                            <th>Sls Qty</th>
                                                                            <th>Ops Asset Type</th>
                                                                            <th>Ops Qty</th>
                                                                            <th>Spare / Non Billable</th>
                                                                            <th>SUP Qty</th>
                                                                            <th>
                                                                                <div style={{ display: "flex", gap: "20px", fontWeight: 600 }}>
                                                                                    <div style={{ width: "120px" }}>Supplied By</div>
                                                                                    <div style={{ width: "140px" }}>ASSET NUMBERS</div>
                                                                                </div>
                                                                            </th>
                                                                            <th>Status</th>
                                                                            <th></th>
                                                                        </tr>
                                                                    </thead>

                                                                    <tbody className="tbody-area-lyt">
                                                                        {summaryData?.summary?.Equipment?.map((eq, i) => {
                                                                            return (
                                                                                <tr key={i} className={eq?.IsDeployed ? 'deployed-row' : ''}>
                                                                                    <td>{eq?.AssetType}</td>
                                                                                    <td>{eq?.SalesQuantity}</td>
                                                                                    <td>{eq?.SupplyChainAssetType}</td>
                                                                                    <td>{eq?.OperationQuantity}</td>
                                                                                    <td>
                                                                                        <div
                                                                                            className={
                                                                                                eq?.OperationQuantity > eq?.SalesQuantity
                                                                                                    ? `spare-box-field summry-txt-discweb`
                                                                                                    : `spare-box-field-disabled`
                                                                                            }
                                                                                        >
                                                                                            <div className="input-wave--asts mb-2">
                                                                                                <span className="text-spare-label light-blue-spare">
                                                                                                    <div className="dot-circle-spare"></div>Spare
                                                                                                </span>
                                                                                                <div className="spare-bill-ast">
                                                                                                    <input
                                                                                                        type="number"
                                                                                                        disabled
                                                                                                        value={eq?.SpareCount}
                                                                                                        className="form-control input-bill-ast"
                                                                                                    />
                                                                                                </div>
                                                                                            </div>

                                                                                            <div className="input-wave--asts">
                                                                                                <span className="text-spare-label light-green-spare">
                                                                                                    <div className="dot-circle-spare"></div>Non Billable
                                                                                                </span>
                                                                                                <div className="spare-bill-ast">
                                                                                                    <input
                                                                                                        type="number"
                                                                                                        disabled
                                                                                                        value={eq?.NonBillableCount}
                                                                                                        className="form-control input-bill-ast"
                                                                                                    />
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </td>
                                                                                    <td>{eq?.SuppliedQuantity}</td>
                                                                                    <td>
                                                                                        <div style={{ display: "flex", gap: "20px" }}>

                                                                                            <div>
                                                                                                {Array.from({
                                                                                                    length: Math.max(
                                                                                                        eq?.SuppliedBy?.length || 0,
                                                                                                        eq?.AssetDetails?.length || 0
                                                                                                    )
                                                                                                }).map((_, index) => (
                                                                                                    <div
                                                                                                        key={index}
                                                                                                        style={{ display: "flex", gap: "20px", marginBottom: "6px" }}
                                                                                                    >
                                                                                                        <div style={{ width: "120px" }}>
                                                                                                            {eq?.SuppliedBy?.[index] || ""}
                                                                                                        </div>
                                                                                                        <div style={{ width: "140px" }}>
                                                                                                            {eq?.AssetDetails?.[index]?.map((ele, i) => (
                                                                                                                <div key={i}>{ele.AssetNo}</div>
                                                                                                            )) || ""}
                                                                                                        </div>
                                                                                                    </div>
                                                                                                ))}
                                                                                            </div>

                                                                                        </div>
                                                                                    </td>
                                                                                    <td>
                                                                                        <span className={`btn-status-prgs ${getStatusClass(eq?.IsDeployed)} text-nowrap`}>
                                                                                            {eq?.IsDeployed == true ? 'Deployed' : 'Active'}
                                                                                        </span>
                                                                                    </td>
                                                                                    <td>
                                                                                        <OverlayTrigger
                                                                                            placement="top"
                                                                                            overlay={
                                                                                                <Tooltip id={eq?.Notes}>
                                                                                                    {eq?.Notes ? `${eq?.Notes}` : "n/a"}
                                                                                                </Tooltip>
                                                                                            }
                                                                                        >
                                                                                            <span style={{ cursor: "pointer" }} className="note-icon-block">
                                                                                                <img style={{ minWidth: '20px' }} src={notesWebIcon} alt="" />
                                                                                            </span>
                                                                                        </OverlayTrigger>
                                                                                    </td>
                                                                                </tr>
                                                                            );
                                                                        })}
                                                                    </tbody>
                                                                </Table>

                                                            </div>
                                                        </div>
                                                    </>
                                                    :
                                                    null
                                            }
                                            {
                                                summaryData?.summary?.Hose?.length ?
                                                    <>
                                                        <div className="multi-category-chartlist">
                                                            <div className="flx-category-emt">
                                                                <div className="flx-icon-wtm"><img src={storageIcon} alt="" /></div>
                                                                <div className="info-wpl-info">
                                                                    <span className="small-tl-sp">Category</span>
                                                                    <h3 className="title-mgt--wp">HOSE</h3>
                                                                </div>
                                                            </div>
                                                            <div className="assets-table-sumry px-4">
                                                                <Table responsive className="table-summary-elemnt">
                                                                    <thead className="thead-web-sumr">
                                                                        <tr>
                                                                            <th>Hose Type</th>
                                                                            <th>HOSE DIAMETER</th>
                                                                            <th>SECTION LENGTH</th>
                                                                            <th>END FITTING TYPE 1</th>
                                                                            <th>END FITTING TYPE 2</th>
                                                                            <th>Qty</th>
                                                                            <th>Supplied By</th>
                                                                            <th>Status</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody className="tbody-area-lyt">
                                                                        {
                                                                            summaryData?.summary && summaryData?.summary?.Hose?.map((hse, i) => {
                                                                                return (
                                                                                    <tr key={i} className={hse?.IsDeployed ? 'deployed-row' : ''}>
                                                                                        <td>{hse?.HoseType}</td>
                                                                                        <td>{hse?.HoseDiameter}</td>
                                                                                        <td>{hse?.SectionLength}</td>
                                                                                        <td>{hse?.EndFittingType1}</td>
                                                                                        <td>{hse?.EndFittingType2}</td>
                                                                                        <td>{hse?.Quantity}</td>
                                                                                        <td>{hse?.SuppliedBy}</td>
                                                                                        <td>
                                                                                            <span className={`btn-status-prgs ${getStatusClass(hse?.IsDeployed)} text-nowrap`}>
                                                                                                {hse?.IsDeployed == true ? 'Deployed' : 'Active'}
                                                                                            </span>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                        }
                                                                    </tbody>
                                                                </Table>
                                                            </div>
                                                        </div>
                                                    </>
                                                    :
                                                    null
                                            }


                                            {
                                                summaryData?.summary?.Items?.length ?
                                                    <>
                                                        <div className="multi-category-chartlist">
                                                            <div className="flx-category-emt">
                                                                <div className="flx-icon-wtm"><img src={storageIcon} alt="" /></div>
                                                                <div className="info-wpl-info">
                                                                    <span className="small-tl-sp">Category</span>
                                                                    <h3 className="title-mgt--wp">ITEMS</h3>
                                                                </div>
                                                            </div>

                                                            {summaryData?.summary && summaryData?.summary?.Items?.map((category, index) => (
                                                                <div key={index} className="assets-table-sumry px-4">
                                                                    <h3 className="title-hs-mt">{category.MasterCategory}</h3>

                                                                    {/* Case 1: Has SubCategory data */}
                                                                    {category.SubCategory && category.SubCategory.length > 0 ? (
                                                                        category.SubCategory.map((subCategory, subIndex) => (
                                                                            <div key={subIndex}>
                                                                                <h5 className="title-hs-mt">{subCategory.MasterCategory}</h5>
                                                                                <Table responsive className="table-summary-elemnt">
                                                                                    <thead className="thead-web-sumr">
                                                                                        <tr>
                                                                                            <th>Item Name</th>
                                                                                            <th>Qty</th>
                                                                                            <th>Supplied By</th>
                                                                                            <th>Status</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody className="tbody-area-lyt">
                                                                                        {subCategory.items.map((item, itemIndex) => (
                                                                                            <tr key={itemIndex} className={item?.IsDeployed ? 'deployed-row' : ''}>
                                                                                                <td className="item-head-wp-1">{item.ItemName}</td>
                                                                                                <td className="item-head-wp-2">{item.Quantity}</td>
                                                                                                <td className="item-head-wp-3">{item.SuppliedBy}</td>
                                                                                                <td>
                                                                                                    <span className={`btn-status-prgs ${getStatusClass(item?.IsDeployed)} text-nowrap`}>
                                                                                                        {item?.IsDeployed == true ? 'Deployed' : 'Active'}
                                                                                                    </span>
                                                                                                </td>
                                                                                            </tr>
                                                                                        ))}
                                                                                    </tbody>
                                                                                </Table>
                                                                            </div>
                                                                        ))
                                                                    ) : (
                                                                        /* Case 2: No SubCategory - loop over items directly */
                                                                        <Table responsive className="table-summary-elemnt">
                                                                            <thead className="thead-web-sumr">
                                                                                <tr>
                                                                                    <th>Item Name</th>
                                                                                    <th>Qty</th>
                                                                                    <th>Supplied By</th>
                                                                                    <th>Status</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody className="tbody-area-lyt">
                                                                                {category.items.map((item, itemIndex) => (
                                                                                    <tr key={itemIndex} className={item?.IsDeployed ? 'deployed-row' : ''}>
                                                                                        <td className="item-head-wp-1">{item.ItemName}</td>
                                                                                        <td className="item-head-wp-2">{item.Quantity}</td>
                                                                                        <td className="item-head-wp-3">{item.SuppliedBy}</td>
                                                                                        <td>
                                                                                            <span className={`btn-status-prgs ${getStatusClass(item?.IsDeployed)} text-nowrap`}>
                                                                                                {item?.IsDeployed == true ? 'Deployed' : 'Active'}
                                                                                            </span>
                                                                                        </td>
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </Table>
                                                                    )}
                                                                </div>
                                                            ))}
                                                        </div>

                                                    </>
                                                    :
                                                    null
                                            }
                                            {
                                                summaryData?.summary?.LabEquipment?.length ?
                                                    <>
                                                        <div className="multi-category-chartlist">
                                                            <div className="flx-category-emt">
                                                                <div className="flx-icon-wtm"><img src={storageIcon} alt="" /></div>
                                                                <div className="info-wpl-info">
                                                                    <span className="small-tl-sp">Category</span>
                                                                    <h3 className="title-mgt--wp">Lab Items</h3>
                                                                </div>
                                                            </div>
                                                            <div className="assets-table-sumry px-4">
                                                                <Table responsive className="table-summary-elemnt">
                                                                    <thead className="thead-web-sumr">
                                                                        <tr>
                                                                            <th>Item Name</th>
                                                                            <th>Qty</th>
                                                                            <th>Supplied By</th>
                                                                            <th>Status</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody className="tbody-area-lyt">
                                                                        {
                                                                            summaryData?.summary && summaryData?.summary?.LabEquipment?.map((lab, i) => {
                                                                                return (
                                                                                    <tr key={i} className={lab?.IsDeployed ? 'deployed-row' : ''}>
                                                                                        <td className="item-head-wp-1">{lab.ItemName}</td>
                                                                                        <td className="item-head-wp-2">{lab.Quantity}</td>
                                                                                        <td className="item-head-wp-3">{lab.SuppliedBy}</td>
                                                                                        <td>
                                                                                            <span className={`btn-status-prgs ${getStatusClass(lab?.IsDeployed)} text-nowrap`}>
                                                                                                {lab?.IsDeployed == true ? 'Deployed' : 'Active'}
                                                                                            </span>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                        }
                                                                    </tbody>
                                                                </Table>
                                                            </div>
                                                        </div>
                                                    </>
                                                    :
                                                    null

                                            }

                                            {
                                                summaryData?.summary?.HSE?.length ?
                                                    <>
                                                        <div className="multi-category-chartlist">
                                                            <div className="flx-category-emt">
                                                                <div className="flx-icon-wtm"><img src={storageIcon} alt="" /></div>
                                                                <div className="info-wpl-info">
                                                                    <span className="small-tl-sp">Category</span>
                                                                    <h3 className="title-mgt--wp">HSE</h3>
                                                                </div>
                                                            </div>
                                                            <div className="assets-table-sumry px-4">
                                                                <Table responsive className="table-summary-elemnt">
                                                                    <thead className="thead-web-sumr">
                                                                        <tr>
                                                                            <th>Item Name</th>
                                                                            <th>Qty</th>
                                                                            <th>Supplied By</th>
                                                                            <th>Status</th>
                                                                            <th></th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody className="tbody-area-lyt">
                                                                        {
                                                                            summaryData?.summary && summaryData?.summary?.HSE?.map((ele, i) => {
                                                                                return (
                                                                                    <tr key={i} className={ele?.IsDeployed ? 'deployed-row' : ''}>
                                                                                        <td className="item-head-wp-1">{ele.ItemName}</td>
                                                                                        <td className="item-head-wp-2">{ele.Quantity}</td>
                                                                                        <td className="item-head-wp-3">{ele.SuppliedBy}</td>
                                                                                        <td>
                                                                                            <span className={`btn-status-prgs ${getStatusClass(ele?.IsDeployed)} text-nowrap`}>
                                                                                                {ele?.IsDeployed == true ? 'Deployed' : 'Active'}
                                                                                            </span>
                                                                                        </td>
                                                                                        <td className="item-head-wp-6">
                                                                                            <OverlayTrigger
                                                                                                placement="top"
                                                                                                overlay={
                                                                                                    <Tooltip id={ele?.Notes}>
                                                                                                        {ele?.Notes ? `${ele?.Notes}` : 'n/a'}
                                                                                                    </Tooltip>
                                                                                                }
                                                                                            >
                                                                                                <span style={{ cursor: 'pointer' }} className="note-icon-block"><img style={{ minWidth: '20px' }} src={notesWebIcon} alt="" /></span>
                                                                                            </OverlayTrigger>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                        }
                                                                    </tbody>
                                                                </Table>
                                                            </div>
                                                        </div>
                                                    </>
                                                    :
                                                    null
                                            }

                                            {
                                                summaryData?.summary?.CustomPackageItem?.length ?
                                                    <>
                                                        <div className="multi-category-chartlist">
                                                            <div className="flx-category-emt">
                                                                <div className="flx-icon-wtm"><img src={storageIcon} alt="" /></div>
                                                                <div className="info-wpl-info">
                                                                    <span className="small-tl-sp">Category</span>
                                                                    <h3 className="title-mgt--wp">Custom Items</h3>
                                                                </div>
                                                            </div>
                                                            <div className="assets-table-sumry px-4">
                                                                <Table responsive className="table-summary-elemnt">
                                                                    <thead className="thead-web-sumr">
                                                                        <tr>
                                                                            <th>Item Name</th>
                                                                            <th>Qty</th>
                                                                            <th>Supplied By</th>
                                                                            <th>Status</th>
                                                                            <th></th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody className="tbody-area-lyt">
                                                                        {
                                                                            summaryData?.summary && summaryData?.summary['CustomPackageItem']?.map((ele, i) => {
                                                                                return (
                                                                                    <tr key={i} className={ele?.IsDeployed ? 'deployed-row' : ''}>
                                                                                        <td className="item-head-wp-1">{ele.ItemName}</td>
                                                                                        <td className="item-head-wp-2">{ele.Quantity}</td>
                                                                                        <td className="item-head-wp-3">{ele.SuppliedBy}</td>
                                                                                        <td>
                                                                                            <span className={`btn-status-prgs ${getStatusClass(ele?.IsDeployed)} text-nowrap`}>
                                                                                                {ele?.IsDeployed == true ? 'Deployed' : 'Active'}
                                                                                            </span>
                                                                                        </td>
                                                                                        <td className="item-head-wp-6">
                                                                                            <OverlayTrigger
                                                                                                placement="top"
                                                                                                overlay={
                                                                                                    <Tooltip id={ele?.Notes}>
                                                                                                        {ele?.Notes ? `${ele?.Notes}` : 'n/a'}
                                                                                                    </Tooltip>
                                                                                                }
                                                                                            >
                                                                                                <span style={{ cursor: 'pointer' }} className="note-icon-block"><img style={{ minWidth: '20px' }} src={notesWebIcon} alt="" /></span>
                                                                                            </OverlayTrigger>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                        }
                                                                    </tbody>
                                                                </Table>
                                                            </div>
                                                        </div>
                                                    </>
                                                    :
                                                    null
                                            }

                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>

                {/* Print-only content - hidden on screen */}
                <div id="print-content" style={{ display: 'none' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                <th style={{ border: 'none', textAlign: 'left', padding: '10px 0' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                        <img src={s3sLogo} alt="S3S Logo" style={{ maxWidth: '100px', maxHeight: '50px' }} />
                                        <h2 style={{ margin: 0 }}>Load Out Summary</h2>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{ border: 'none', padding: '5px 0' }}>
                                    {/* Job details and general information */}
                                    <div className="print-header-info">
                                        <p><strong>Job Name:</strong> {summaryData?.jobDetails?.[0]?.JobName}</p>
                                        <p><strong>Customer:</strong> {summaryData?.jobDetails?.[0]?.CustomerName}</p>
                                        <p><strong>Rig/Platform:</strong> {summaryData?.jobDetails?.[0]?.PlatformName}</p>
                                        <p><strong>Internal Job ID:</strong> {summaryData?.generalInformation?.[0]?.ID}</p>
                                        <p><strong>Primary Basin:</strong> {summaryData?.generalInformation?.[0]?.PrimaryBasin}</p>
                                    </div>
                                </td>
                            </tr>

                            {/* EQUIPMENT - all items */}
                            {summaryData?.summary?.Equipment?.length > 0 && (
                                <tr>
                                    <td style={{ border: 'none', padding: '5px 0' }}>
                                        <div className="print-category">
                                            <h3>EQUIPMENT</h3>
                                            <table className="print-table equipment-table">
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: '12%' }}>Sls Asset Type</th>
                                                        <th style={{ width: '6%' }}>Sls Qty</th>
                                                        <th style={{ width: '12%' }}>Ops Asset Type</th>
                                                        <th style={{ width: '6%' }}>Ops Qty</th>
                                                        <th style={{ width: '12%' }}>Spare/Non Bill</th>
                                                        <th style={{ width: '6%' }}>SUP Qty</th>
                                                        <th style={{ width: '30%' }}>Supplied By / Asset Numbers</th>
                                                        <th style={{ width: '8%' }}>Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {summaryData.summary.Equipment.map((eq, i) => (
                                                        <tr key={i}>
                                                            <td>{eq.AssetType}</td>
                                                            <td>{eq.SalesQuantity}</td>
                                                            <td>{eq.SupplyChainAssetType}</td>
                                                            <td>{eq.OperationQuantity}</td>
                                                            <td>
                                                                {eq.OperationQuantity > eq.SalesQuantity ? (
                                                                    <>
                                                                        <div>Spare: {eq.SpareCount}</div>
                                                                        <div>Non Bill: {eq.NonBillableCount}</div>
                                                                    </>
                                                                ) : '—'}
                                                            </td>
                                                            <td>{eq.SuppliedQuantity}</td>
                                                            <td>
                                                                {eq.SuppliedBy?.map((supplier, idx) => (
                                                                    <div key={idx}>
                                                                        <strong>{supplier}:</strong>{' '}
                                                                        {eq.AssetDetails?.[idx]?.map(a => a.AssetNo).join(', ')}
                                                                    </div>
                                                                ))}
                                                            </td>
                                                            <td>{eq.IsDeployed ? 'Deployed' : 'Active'}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            )}

                            {/* HOSE - all items */}
                            {summaryData?.summary?.Hose?.length > 0 && (
                                <tr>
                                    <td style={{ border: 'none', padding: '5px 0' }}>
                                        <div className="print-category">
                                            <h3>HOSE</h3>
                                            <table className="print-table">
                                                <thead>
                                                    <tr>
                                                        <th>Hose Type</th>
                                                        <th>Diameter</th>
                                                        <th>Length</th>
                                                        <th>End Fitting 1</th>
                                                        <th>End Fitting 2</th>
                                                        <th>Qty</th>
                                                        <th>Supplied By</th>
                                                        <th>Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {summaryData.summary.Hose.map((hse, i) => (
                                                        <tr key={i}>
                                                            <td>{hse.HoseType}</td>
                                                            <td>{hse.HoseDiameter}</td>
                                                            <td>{hse.SectionLength}</td>
                                                            <td>{hse.EndFittingType1}</td>
                                                            <td>{hse.EndFittingType2}</td>
                                                            <td>{hse.Quantity}</td>
                                                            <td>{hse.SuppliedBy}</td>
                                                            <td>{hse.IsDeployed ? 'Deployed' : 'Active'}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            )}

                            {/* ITEMS - all items (with subcategories) */}
                            {summaryData?.summary?.Items?.length > 0 && (
                                <tr>
                                    <td style={{ border: 'none', padding: '5px 0' }}>
                                        <div className="print-category">
                                            <h3>ITEMS</h3>
                                            {summaryData.summary.Items.map((category, idx) => {
                                                if (category.SubCategory && category.SubCategory.length > 0) {
                                                    return (
                                                        <div key={idx} className="print-subcategory">
                                                            <h4>{category.MasterCategory}</h4>
                                                            {category.SubCategory.map((sub, subIdx) => (
                                                                <div key={subIdx}>
                                                                    <h5>{sub.MasterCategory}</h5>
                                                                    <table className="print-table">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Item Name</th>
                                                                                <th>Qty</th>
                                                                                <th>Supplied By</th>
                                                                                <th>Status</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {sub.items.map((item, itemIdx) => (
                                                                                <tr key={itemIdx}>
                                                                                    <td>{item.ItemName}</td>
                                                                                    <td>{item.Quantity}</td>
                                                                                    <td>{item.SuppliedBy}</td>
                                                                                    <td>{item.IsDeployed ? 'Deployed' : 'Active'}</td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    );
                                                } else {
                                                    return (
                                                        <div key={idx}>
                                                            <h4>{category.MasterCategory}</h4>
                                                            <table className="print-table">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Item Name</th>
                                                                        <th>Qty</th>
                                                                        <th>Supplied By</th>
                                                                        <th>Status</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {category.items.map((item, itemIdx) => (
                                                                        <tr key={itemIdx}>
                                                                            <td>{item.ItemName}</td>
                                                                            <td>{item.Quantity}</td>
                                                                            <td>{item.SuppliedBy}</td>
                                                                            <td>{item.IsDeployed ? 'Deployed' : 'Active'}</td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    );
                                                }
                                            })}
                                        </div>
                                    </td>
                                </tr>
                            )}

                            {/* LAB EQUIPMENT - all items */}
                            {summaryData?.summary?.LabEquipment?.length > 0 && (
                                <tr>
                                    <td style={{ border: 'none', padding: '5px 0' }}>
                                        <div className="print-category">
                                            <h3>LAB ITEMS</h3>
                                            <table className="print-table">
                                                <thead>
                                                    <tr>
                                                        <th>Item Name</th>
                                                        <th>Qty</th>
                                                        <th>Supplied By</th>
                                                        <th>Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {summaryData.summary.LabEquipment.map((lab, i) => (
                                                        <tr key={i}>
                                                            <td>{lab.ItemName}</td>
                                                            <td>{lab.Quantity}</td>
                                                            <td>{lab.SuppliedBy}</td>
                                                            <td>{lab.IsDeployed ? 'Deployed' : 'Active'}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            )}

                            {/* HSE - all items */}
                            {summaryData?.summary?.HSE?.length > 0 && (
                                <tr>
                                    <td style={{ border: 'none', padding: '5px 0' }}>
                                        <div className="print-category">
                                            <h3>HSE</h3>
                                            <table className="print-table">
                                                <thead>
                                                    <tr>
                                                        <th>Item Name</th>
                                                        <th>Qty</th>
                                                        <th>Supplied By</th>
                                                        <th>Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {summaryData.summary.HSE.map((hse, i) => (
                                                        <tr key={i}>
                                                            <td>{hse.ItemName}</td>
                                                            <td>{hse.Quantity}</td>
                                                            <td>{hse.SuppliedBy}</td>
                                                            <td>{hse.IsDeployed ? 'Deployed' : 'Active'}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            )}

                            {/* CUSTOM ITEMS - all items */}
                            {summaryData?.summary?.CustomPackageItem?.length > 0 && (
                                <tr>
                                    <td style={{ border: 'none', padding: '5px 0' }}>
                                        <div className="print-category">
                                            <h3>CUSTOM ITEMS</h3>
                                            <table className="print-table">
                                                <thead>
                                                    <tr>
                                                        <th>Item Name</th>
                                                        <th>Qty</th>
                                                        <th>Supplied By</th>
                                                        <th>Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {summaryData.summary.CustomPackageItem.map((cust, i) => (
                                                        <tr key={i}>
                                                            <td>{cust.ItemName}</td>
                                                            <td>{cust.Quantity}</td>
                                                            <td>{cust.SuppliedBy}</td>
                                                            <td>{cust.IsDeployed ? 'Deployed' : 'Active'}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}
export default ViewSummary;